import z from 'zod'

// Canadian provinces schema
export const ProvinceSchema = z
  .string()
  .regex(
    /^(AB|BC|MB|NB|NL|NS|NT|NU|ON|PE|QC|SK|YT)$/,
    'Province must be a valid Canadian province code (e.g., ON, BC, QC)',
  )
